import { render, staticRenderFns } from "./FicheBeneficiaire.vue?vue&type=template&id=6dee9829&scoped=true"
import script from "./FicheBeneficiaire.vue?vue&type=script&lang=js"
export * from "./FicheBeneficiaire.vue?vue&type=script&lang=js"
import style0 from "./FicheBeneficiaire.vue?vue&type=style&index=0&id=6dee9829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee9829",
  null
  
)

export default component.exports